(function () {
  'use strict';

  /*
   * <yarnly-footer>
   * Syncs the mobile accordions ([data-footer-accordion] <details>) with the viewport:
   * collapsed on mobile, always open from 750px up. Everything is read from the DOM.
   */
  if (!customElements.get('yarnly-footer')) {
    class YarnlyFooter extends HTMLElement {
      constructor() {
        super();
        this.onMediaChange = this.onMediaChange.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.details = Array.prototype.slice.call(this.querySelectorAll('[data-footer-accordion]'));
        if (!this.details.length) return;

        this.mql = window.matchMedia('(min-width: 750px)');
        this.sync(this.mql.matches);

        if (typeof this.mql.addEventListener === 'function') {
          this.mql.addEventListener('change', this.onMediaChange);
        } else if (typeof this.mql.addListener === 'function') {
          this.mql.addListener(this.onMediaChange);
        }

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        if (this.mql) {
          if (typeof this.mql.removeEventListener === 'function') {
            this.mql.removeEventListener('change', this.onMediaChange);
          } else if (typeof this.mql.removeListener === 'function') {
            this.mql.removeListener(this.onMediaChange);
          }
        }
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onMediaChange(event) {
        this.sync(event.matches);
      }

      sync(isDesktop) {
        this.details.forEach(function (details) {
          details.open = isDesktop;
          details.classList.add('is-ready');
        });
      }

      onBlockSelect(event) {
        if (!event.detail || !event.detail.blockId) return;
        if (this.mql && this.mql.matches) return;
        this.details.forEach(function (details) {
          if (details.getAttribute('data-block-id') === event.detail.blockId) {
            details.open = true;
          }
        });
      }
    }

    customElements.define('yarnly-footer', YarnlyFooter);
  }
})();
